// extracted by mini-css-extract-plugin
export default {"content":"AdminPageTemplate_content__s7A2w"};